// @ts-strict-ignore
import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { whatsappPath } from "./urls";
import WhatsAppPage from "./views/WhatsAppPage";

export const WhatsAppSection: React.FC<RouteComponentProps<any>> = () => (
  <>
    <WindowTitle title="WhatsApp Broadcast & Campaigns" />
    <Switch>
      <Route exact path={whatsappPath} component={WhatsAppPage} />
    </Switch>
  </>
);

export default WhatsAppSection;
